// https://developers.google.com/analytics/devguides/collection/ga4/uid-data?hl=pt-br

function normalizeEmail(email) {
  if (!email) return null
  let normalized = email.toLowerCase().trim()

  if (
    normalized.includes('@gmail.com') ||
    normalized.includes('@googlemail.com')
  ) {
    const [localPart, domain] = normalized.split('@')
    normalized = localPart.replace(/\./g, '') + '@' + domain
  }

  normalized = normalized.replace(/\s/g, '')
  return normalized
}

function normalizePhone(phone) {
  if (!phone) return null
  let normalized = phone.replace(/[^0-9]/g, '')
  if (normalized && !normalized.startsWith('+')) {
    normalized = '+' + normalized
  }

  return normalized
}

function normalizePersonName(name) {
  if (!name) return null
  let normalized = name.replace(/[^a-zA-ZÀ-ÿ\s]/g, '')
  normalized = normalized.toLowerCase().trim()
  if (!normalized) return null

  return normalized
}

function normalizeAddress(address) {
  if (!address) return null
  let normalized = address.replace(/[^a-zA-ZÀ-ÿ0-9\s]/g, '')
  normalized = normalized.toLowerCase().trim()
  if (!normalized) return null

  return normalized
}

function normalizeCity(city) {
  if (!city) return null
  let normalized = city.replace(/[^a-zA-ZÀ-ÿ\s]/g, '')
  normalized = normalized.toLowerCase().trim()
  return normalized || null
}

function normalizePostalCode(postalCode) {
  if (!postalCode) return null
  const normalized = postalCode.replace(/[.~\s]/g, '')
  return normalized || null
}

function sanitize(value, removeDashes) {
  if (!value) return undefined
  const val = String(value)
  let sanitized = val

  sanitized = val.normalize('NFD').replace(/[\u0300-\u036F]/g, '')

  if (removeDashes) {
    sanitized = sanitized.replace(/-/g, '')
  }

  sanitized = sanitized.trim()
  return sanitized || undefined
}

export default {
  normalizeEmail,
  sanitize,
  normalizePhone,
  normalizePersonName,
  normalizeAddress,
  normalizeCity,
  normalizePostalCode,
}
